import { Input, message, Spin } from "antd";
import styles from "./styles.module.scss";
import { EmailLabelIcon } from "icons";
import { useState } from "react";
import { UseLazyApiCallOldDashboard } from "hooks/use-lazy-api-call-old-dashboard";

export const EmailInput = ({ item, userDetails }) => {
  const [email, setEmail] = useState(userDetails?.email);

  function handleChange(e) {
    setEmail(e.target.value);
  }
  const [sendLinkOnEmail, { isLoading: sendLinkOnEmailloading }] =
    UseLazyApiCallOldDashboard({
      method: "POST",
    });

  async function sendResetLinkOnEmail({ apiPath }) {
    try {
      const response = await sendLinkOnEmail({
        url: `${apiPath}`,
        params: {
          email: userDetails?.email,
          name: `${userDetails?.firstName} ${userDetails?.lastName}`,
        },
      });
      if (response.status === "Success") {
        message.success(
          `Reset Link sent successfully on ${userDetails?.email}`
        );
      }
    } catch (error) {
      console.log({ error });
    }
  }

  function handleOnClick(event, item) {
    event.preventDefault();
    if (item.key === "deactivate") return;
    sendResetLinkOnEmail({ apiPath: item.apiPath });
  }

  return (
    <form>
      <div className={styles.cardContainer} key={item.title}>
        <div>
          <item.icon />
        </div>
        <div className={styles.title}>{item.title}</div>
        <div className={styles.desc}>{item.desc}</div>
        <div className={styles.emailContainer}>
          <div className={styles.label}>
            <EmailLabelIcon height={20} width={20} />
            <label htmlFor="email"> {item.emailLabel}</label>
          </div>
          <Input
            type="email"
            value={email}
            onChange={handleChange}
            required
            disabled
          />
        </div>
        <Spin spinning={sendLinkOnEmailloading}>
          <button
            style={{
              backgroundColor: `${item.BtnBgColor}`,
            }}
            onClick={(event) => handleOnClick(event, item)}
            type="submit"
          >
            {item.buttonText}
          </button>
        </Spin>
      </div>
    </form>
  );
};
